import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { AccessTypeDetailComponent } from '../../components/access-type-detail/access-type-detail.component';
import { AccessTypeGridComponent } from '../../components/access-type-grid/access-type-grid.component';
import { IndexDetailComponent } from '../../components/index-detail/index-detail.component';
import { IndexGridComponent } from '../../components/index-grid/index-grid.component';
import { MaterialDetailComponent } from '../../components/material-detail/material-detail.component';
import { MaterialsGridComponent } from '../../components/materials-grid/materials-grid.component';
import { ShipDetailComponent } from '../../components/ship-detail/ship-detail.component';
import { ShipGridComponent } from '../../components/ship-grid/ship-grid.component';
import { SiteModeDetailComponent } from '../../components/site-mode-detail/site-mode-detail.component';
import { SiteModeGridComponent } from '../../components/site-mode-grid/site-mode-grid.component';
import { Location } from '@angular/common';
import { MatTabGroup } from '@angular/material/tabs';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-repository',
  templateUrl: './repository.component.html',
  styleUrls: ['./repository.component.scss'],
})
export class RepositoryComponent implements OnInit {

  panelOpenState = false;

  @ViewChild('MaterialsGridComponent') materialsGridComponent: MaterialsGridComponent;
  @ViewChild('IndexsGridComponent') indexsGridComponent: IndexGridComponent;
  @ViewChild('SiteModeGridComponent') siteModeGridComponent: SiteModeGridComponent;
  @ViewChild('AccessTypeGridComponent') accessTypeGridComponent: AccessTypeGridComponent;
  @ViewChild('ShipGridComponent') shipGridComponent: ShipGridComponent;
  @ViewChild("tabGroup", { static: true }) tabGroup: MatTabGroup;

  constructor(
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location
  ) { }

  ngOnInit() {
    if (this.route.snapshot.queryParams.selectedTab != null) {
      this.tabGroup.selectedIndex = parseInt(this.route.snapshot.queryParams.selectedTab);
    }
    else {
      const url = this.router.createUrlTree(
        [],
        {
          relativeTo: this.route,
          queryParams: { selectedTab: 0 }
        }
      ).toString()
      this.location.go(url);
    }
    this.tabGroup.selectedIndexChange.subscribe(value => {
      const url = this.router.createUrlTree(
        [],
        {
          relativeTo: this.route,
          queryParams: { selectedTab: value }
        }
      ).toString()
      this.location.go(url);
    })
  }
  onSubmit() { }

  createIndex() {
    const data = null;
    const dialogRef = this.dialog.open(IndexDetailComponent, {
      data,
      hasBackdrop: true
    });
    dialogRef.afterClosed().subscribe(success => {
      if (success) {
        this.indexsGridComponent.getIndexs();
      }
    });
  }

  createMaterial() {
    const data = null;
    const dialogRef = this.dialog.open(MaterialDetailComponent, {
      data,
      hasBackdrop: true
    });
    dialogRef.afterClosed().subscribe(success => {
      if (success) {
        this.materialsGridComponent.getMaterials();
      }
    });
  }

  createSiteMode() {
    const data = null;
    const dialogRef = this.dialog.open(SiteModeDetailComponent, {
      data,
      hasBackdrop: true
    });
    dialogRef.afterClosed().subscribe(success => {
      if (success) {
        this.siteModeGridComponent.getSiteModes();
      }
    });
  }

  createAccessType() {
    const data = null;
    const dialogRef = this.dialog.open(AccessTypeDetailComponent, {
      data,
      hasBackdrop: true
    });
    dialogRef.afterClosed().subscribe(success => {
      if (success) {
        this.accessTypeGridComponent.getAccessTypes();
      }
    });
  }

  createShip() {
    const data = null;
    const dialogRef = this.dialog.open(ShipDetailComponent, {
      data,
      hasBackdrop: true
    });
    dialogRef.afterClosed().subscribe(success => {
      if (success) {
        this.shipGridComponent.getShips();
      }
    });
  }

}
